module.exports = __webpack_public_path__ + "static/img/baojingqueren.79a4dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/baojingqueren.png
// module id = uGnL
// module chunks = 24